import { dataSettings } from '../../data/dataSettings'
import { useSettingsStore } from '../../stores/settings'

const TablesSettings = () => {

  const { setTabSettings } = useSettingsStore();

  return (
    <ul className="flex flex-col gap-2">
      {dataSettings.map((item) => (
        <li key={item.id}>
          <button
            type="button"
            onClick={() => setTabSettings(item.title)}
            className="group flex w-full cursor-pointer items-center gap-3 rounded-xl border border-slate-200 bg-white p-3.5 text-left transition-colors hover:border-indigo-200 hover:bg-indigo-50/40 focus-visible:ring-2 focus-visible:ring-indigo-300 focus-visible:outline-none sm:gap-4 sm:p-4"
          >
            <span
              aria-hidden="true"
              className="flex size-11 shrink-0 items-center justify-center rounded-xl bg-slate-50 ring-1 ring-slate-200 ring-inset transition-colors group-hover:bg-white"
            >
              <img src={item.icon} alt="" aria-hidden="true" className="size-5.5" />
            </span>

            <span className="min-w-0 flex-1">
              <span className="block font-Nunito text-sm font-bold text-slate-900 sm:text-base">
                {item.title}
              </span>
              <span className="mt-0.5 block font-Nunito text-xs text-slate-500 sm:text-sm">
                {item.description}
              </span>
            </span>

            <svg
              aria-hidden="true"
              className="size-4 shrink-0 text-slate-400 transition-transform duration-200 group-hover:translate-x-0.5 group-hover:text-dca-blue"
              fill="none"
              stroke="currentColor"
              strokeWidth={2.2}
              viewBox="0 0 24 24"
            >
              <path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7" />
            </svg>
          </button>
        </li>
      ))}
    </ul>
  )
}

export default TablesSettings
